import React from 'react';
import { useDispatch } from 'react-redux';
import {
  changePlayernameToFind,
  dropFiltersToSettingsState,
  findAutopastePlayer,
  findStats,
} from '../containers/StatPage/actions';
import {
  isAutopasteExtensionMessage,
  isAutopasteExtensionStatsMessage,
} from '../extension/autopasteExtension';
import { getAutopasteLocalStorage } from '../localStorage/autopasteLocalStorage';

export default function useAutopasteExtensionBridge() {
  const dispatch = useDispatch();
  const lastSearchedKeyRef = React.useRef<string>();

  React.useEffect(() => {
    const handleExtensionMessage = (event: MessageEvent) => {
      if (event.source !== window || event.origin !== window.location.origin) {
        return;
      }

      if (!getAutopasteLocalStorage()) {
        return;
      }

      if (isAutopasteExtensionStatsMessage(event.data)) {
        const searchKey = `${event.data.playername}:${event.data.pokersiteId}`;

        if (lastSearchedKeyRef.current === searchKey) {
          return;
        }

        lastSearchedKeyRef.current = searchKey;
        dispatch(dropFiltersToSettingsState());
        dispatch(
          findStats({
            playername: event.data.playername,
            pokersiteId: event.data.pokersiteId,
          }),
        );
        return;
      }

      if (!isAutopasteExtensionMessage(event.data)) {
        return;
      }

      const nickname = event.data.nickname;
      if (!nickname || lastSearchedKeyRef.current === nickname) {
        return;
      }

      lastSearchedKeyRef.current = nickname;
      dispatch(changePlayernameToFind(nickname));
      dispatch(findAutopastePlayer(nickname));
    };

    window.addEventListener('message', handleExtensionMessage);

    return () => {
      window.removeEventListener('message', handleExtensionMessage);
    };
  }, [dispatch]);
}
